import React, { ChangeEvent } from 'react'
import { IVoucher } from '../../../model/customer.model'
import { DropdownProps, Form, Icon, Popup, List } from 'semantic-ui-react'
import { inject, observer } from 'mobx-react'
import { RootStore } from '../../../model/root-store'
import { format } from 'date-fns'

interface ISelectVoucherProps {
  availableVouchers: IVoucher[]
  rootStore?: RootStore
}

export const SelectVoucher = inject('rootStore')(
  observer(
    class extends React.Component<ISelectVoucherProps> {
      handleSelectVoucher = (e: any, props: DropdownProps) => {
        const matchVoucher = this.props.availableVouchers.find(
          voucher => voucher._id === props.value
        )
        if (matchVoucher) {
          this.props.rootStore!.orderStore.setVoucher(matchVoucher)
        }
      }

      handleSelect = (e: ChangeEvent<HTMLSelectElement>) => {
        // If empty value selected, set voucher to null (no voucher)
        if (e.target.value === '') {
          this.props.rootStore!.orderStore.setVoucher(null)
          return
        }
        
        const matchVoucher = this.props.availableVouchers.find(
          voucher => voucher._id === e.target.value
        )

        if (matchVoucher) {
          this.props.rootStore!.orderStore.setVoucher(matchVoucher)
        }
      }

      renderVoucherDetails = (voucher: IVoucher) => {
        return (
          <List>
            {!voucher.amount && !voucher.quantity ? null : (
              <List.Item>
                <List.Icon name="money" />
                <List.Content>
                  Giá trị: {(voucher.amount || voucher.quantity || 0).toLocaleString('vi-VN')}đ
                </List.Content>
              </List.Item>
            )}
            {voucher.minValueOrder ? (
              <List.Item>
                <List.Icon name="cart" />
                <List.Content>
                  Đơn tối thiểu: {voucher.minValueOrder.toLocaleString('vi-VN')}đ
                </List.Content>
              </List.Item>
            ) : null}
            {voucher.expiryDate ? (
              <List.Item>
                <List.Icon name="calendar times" />
                <List.Content>
                  Hết hạn: {format(new Date(voucher.expiryDate), 'DD/MM/YYYY')}
                </List.Content>
              </List.Item>
            ) : null}
          </List>
        )
      }

      render() {
        const orderStore = this.props.rootStore!.orderStore

        return (
          <Form>
            <Form.Field inline>
              <label>
                Voucher
                {!orderStore.voucher ? null : (
                  <Popup
                    trigger={
                      <Icon
                        name="info circle"
                        color="blue"
                        style={{ marginLeft: '5px', cursor: 'pointer' }}
                      />
                    }
                    content={this.renderVoucherDetails(orderStore.voucher)}
                    position="top center"
                    wide
                  />
                )}
              </label>
              <select
                onChange={this.handleSelect}
                value={orderStore.voucher ? orderStore.voucher._id : ''}
                style={{ minWidth: '250px' }}
              >
                <option value="">-- Chọn voucher --</option>
                {orderStore.availableVouchers.map(voucher => {
                  const isExpired = voucher.expiryDate && new Date(voucher.expiryDate) < new Date()
                  const displayText = `${voucher.name}${
                    voucher.amount ? ` (${voucher.amount.toLocaleString('vi-VN')}đ)` : ''
                  }${isExpired ? ' [Hết hạn]' : ''}`

                  return (
                    <option key={voucher._id} value={voucher._id} disabled={isExpired}>
                      {displayText}
                    </option>
                  )
                })}
              </select>
            </Form.Field>
          </Form>
        )
      }
    }
  )
)
